export default __webpack_public_path__ + "static/scores@768_2x-0989d23faa5ecfd0442a922b0c5c2f84.png";